import StyleImporter from '@/scripts/Components/Utilities/StyleImporter';

class VSVueGlobalComponents {
  init() {
    return {
      components: {
        StyleImporter,
      },

      data() {
        return {
          isReady: false,
          globaModal_slotComponent: false,
        };
      },

      computed: {
        globalModal() {
          const globalModal = this.$store.state.notification.globalModal;
          if (this.isReady) { // Force recomputation when component is mounted
            if (globalModal.show && globalModal.slot && globalModal.slot.component) {
              // Asynchronously resolve slot component~
              this.$_globalModal_local_resolveComponent(globalModal.slot.component)
                .then((component) => {
                  if (globalModal.show) { // Reassure that is still valid after component resolvation
                    this.$_globalModal_local_show(component);
                  }
                })
                .catch((error) => {
                  this.$_globalModal_local_hide();
                  throw error;
                });
            } else {
              this.$_globalModal_local_hide();
            }
          }

          return globalModal;
        },
      },

      mounted() {
        this.$nextTick(() => {
          this.$_globalModal_messageFn('show');
          this.isReady = true;
        });
      },

      methods: {
        $_globalModal_messageFn(event, payload) {
          this.globalModal.responseFn(event, payload);
        },

        // Modal before close handler
        $_globalModal_close() {
          this.$store.dispatch('notification/modal_close');
          this.$_globalModal_messageFn('close');
        },

        // Local methods that will be executed upon receiving instruction from parent/store
        $_globalModal_local_show(component) {
          this.globaModal_slotComponent = component;
          this.$modal.show('global_modal');
          this.$_globalModal_messageFn('show');
        },
        $_globalModal_local_hide() {
          this.globaModal_slotComponent = false;
          this.$modal.hide('global_modal');
        },
        $_globalModal_local_resolveComponent(component) {
          return Promise.resolve(component)
            .then((component) => (
              (typeof component === 'string')
                ? import('./' + component)
                : component
            ))
            .then(component => component.default || component)
          ;
        },
      },
    };
  }
};

export default new VSVueGlobalComponents();
